export var commonColorsTokens = {
  'colors-success': 'var(--lmn-ds-colors-success-400)',
  'colors-success-50': '#f5fbee',
  'colors-success-100': '#f1f7e6',
  'colors-success-200': '#b2db80',
  'colors-success-300': '#84c533',
  'colors-success-400': '#65b700',
  'colors-success-500': '#5ba500',
  'colors-success-600': '#519200',
  'colors-success-700': '#478000',
  'colors-success-800': '#335c00',
  'colors-warning': 'var(--lmn-ds-colors-warning-400)',
  'colors-warning-50': '#fff8eb',
  'colors-warning-100': '#fff2dA',
  'colors-warning-200': '#ffd583',
  'colors-warning-300': '#ffbb38',
  'colors-warning-400': '#ffaa06',
  'colors-warning-500': '#ff7903',
  'colors-warning-600': '#ff4800',
  'colors-warning-700': '#eb4200',
  'colors-warning-800': '#b13200',
  'colors-danger': 'var(--lmn-ds-colors-danger-400)',
  'colors-danger-50': '#ffe9eb',
  'colors-danger-100': '#fddcdf',
  'colors-danger-200': '#f98a95',
  'colors-danger-300': '#f65b6a',
  'colors-danger-400': '#f2142a',
  'colors-danger-500': '#dd0016',
  'colors-danger-600': '#ba0012',
  'colors-danger-700': '#99000f',
  'colors-danger-800': '#73000b',
  'colors-gray': 'var(--lmn-ds-colors-gray-400)',
  'colors-gray-0': '#fff',
  'colors-gray-50': '#f5f5f5',
  'colors-gray-100': '#eaeaeb',
  'colors-gray-200': '#babac0',
  'colors-gray-300': '#9f9fa4',
  'colors-gray-400': '#74747c',
  'colors-gray-500': '#828289',
  'colors-gray-600': '#76767b',
  'colors-gray-700': '#55555a',
  'colors-gray-800': '#3c3c3c',
  'colors-gray-1000': '#000',
  'colors-informative': 'var(--lmn-ds-colors-informative-400)',
  'colors-informative-50': '#ecf7fe',
  'colors-informative-100': '#b3e0fb',
  'colors-informative-200': '#8cd0f9',
  'colors-informative-300': '#66c1f7',
  'colors-informative-400': '#40B1F5',
  'colors-informative-500': '#0078d4',
  'colors-informative-600': '#338ec4',
  'colors-informative-700': '#2d7cac',
  'colors-informative-800': '#005494',
  'colors-fs-primary': '#FFB511',
  'colors-fs-primary-light': '#FFE1A0',
  'colors-fs-primary-dark': '#F08834',
  'colors-fs-secondary': '#441973',
  'colors-fs-secondary-light': '#EFECF1',
  'colors-eb': '#00A0E0',
  'colors-eb-light': '#CCF0FF',
  'colors-myprice': '#32b1bE',
  'colors-myprice-light': '#d7f2f4',
  'colors-myprice-dark': '#288E98',
  'colors-tsh': '#65277F',
  'colors-tsh-light': '#EBD8F3',
  'colors-grayscale-sand': '#FBF8F6',
  'colors-grayscale-light': '#808D95',
  'colors-grayscale-inactive-tab': '#5D6E79',
  'colors-grayscale-text': '#3B505E',
  'colors-trust-you-fair': '#F8CE72',
  'colors-trust-you-other': '#D9D4CA',
  'colors-trust-you-poor': '#D9D4CA',
  'colors-trust-you-good': '#BFCC4E',
  'colors-trust-you-verygood': '#A0CA3F',
  'colors-trust-you-excellent': '#7CB342'
};